function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// You can blame Sam Huckaby for this file
export var DynamicOrderItems =
/*#__PURE__*/
function () {
  function DynamicOrderItems($stateParams, $timeout, AssetResourceFactory, OrderResourceFactory, statusService, DestinationResourceFactory, groupId) {
    _classCallCheck(this, DynamicOrderItems);

    /* BINDABLE : INJECTS */
    Object.assign(this, {
      $stateParams: $stateParams,
      $timeout: $timeout,
      AssetResourceFactory: AssetResourceFactory,
      OrderResourceFactory: OrderResourceFactory,
      statusService: statusService,
      DestinationResourceFactory: DestinationResourceFactory,
      groupId: groupId
    });
    /* BINDABLE : DATA */

    var scrubbedParams = angular.copy($stateParams);
    delete scrubbedParams.id;
    this.SearchParams = scrubbedParams;
    this.spotThumbs = {};
    this.destinationStatuses = {};
    this.loadingGroup = false;
    /* EVENTS */
    //Register any event listeners
    // Start things rolling

    this.reloadPages_(groupId);
  }
  /* IMPLEMENTATION : BINDABLE */


  _createClass(DynamicOrderItems, [{
    key: "getItemAtIndex",
    value: function getItemAtIndex(index) {
      var pageNumber = Math.floor(index / this.PAGE_SIZE);
      var page = this.loadedPages[pageNumber];

      if (page) {
        return page[index % this.PAGE_SIZE];
      } else if (page !== null) {
        this.fetchPage_(pageNumber);
      }
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return this.numItems;
    }
  }, {
    key: "setItemAtIndex",
    value: function setItemAtIndex(index, item) {
      var pageNumber = Math.floor(index / this.PAGE_SIZE);
      var page = this.loadedPages[pageNumber]; // Only update the screen if the spot is currently loaded

      if (page) {
        page[index % this.PAGE_SIZE] = item;
      }
    }
  }, {
    key: "fetchPage_",
    value: function fetchPage_(pageNumber) {
      var self = this; // Set the page to null so we know it is already being fetched.

      self.loadedPages[pageNumber] = null;
      var pageOffset = pageNumber * self.PAGE_SIZE;
      self.$timeout(function () {
        var SearchParams = {};
        SearchParams.offset = pageOffset;
        SearchParams.limit = self.PAGE_SIZE;
        SearchParams.id = self.groupId;
        self.loadingGroup = true;
        self.OrderResourceFactory.getOrderItems(SearchParams, function (group) {
          group = group.data;
          self.loadingGroup = false; // Preset all of the statuses with each new page requested (so we don't end up doing them all at the same time

          for (var i = 0; i < group.rows.length; i++) {
            group.rows[i].statusBar = self.statusService.readOrderItemStatus(group.rows[i]);
          }

          self.loadedPages[pageNumber] = group.rows;
          self.numItems = group.count; // load the spot thumbnails

          self.loadedPages[pageNumber] = self.loadedPages[pageNumber].map(function (item, ind, list) {
            if (item.Spot && item.Spot.Storyboard[0] && item.Spot.Storyboard[0].Asset) {
              self._getThumbnail(item.Spot.isci, item.Spot.Storyboard[0].Asset.AssetContent.contentUuid);
            }

            if (item.Destination) {
              self._getDestinationStatus(item.Destination.distributionType, item.Destination.ReceiverAccount.id, item.Destination.id);
            }

            return item;
          });
          self.$timeout(function () {
            angular.element(window).triggerHandler('resize');
          });
        }, function (error) {
          self.loadingGroup = false;
          self.loadedPages[pageNumber] = [];
        });
      });
    }
  }, {
    key: "reloadPages_",
    value: function reloadPages_(groupId) {
      /**
       * @type {!Object<?Array>} Data pages, keyed by page number (0-index).
       */
      this.loadedPages = {};
      /** @type {number} Total number of items. */

      this.numItems = 0;
      /** @const {number} Number of items to fetch per request. */

      this.PAGE_SIZE = 50;
      /** @const {number} group id of the group this infinite scroll is controlling. */

      this.groupId = groupId;
      this.getItemAtIndex(0);
    }
    /* IMPLEMENTATION : PRIVATE */
    // All private methods should start with '_' in order to distinguish them

  }, {
    key: "_getThumbnail",
    value: function _getThumbnail(isci, uuid) {
      var _this = this;

      if (this.spotThumbs && !this.spotThumbs[isci]) {
        this.AssetResourceFactory.getImageAsset({
          uuid: uuid
        }, {}, function (asset) {
          var blob = new Blob([asset.data], {
            type: asset.config['Content-Type']
          });
          _this.spotThumbs[isci] = URL.createObjectURL(blob);
        }, function failure(err) {
          console.log(err); // Unable to retrieve the image asset for the thumbnail
        });
      }
    }
  }, {
    key: "_getDestinationStatus",
    value: function _getDestinationStatus(distributionType, receiverId, destinationId) {
      var _this2 = this;

      if (this.destinationStatuses && !this.destinationStatuses[destinationId]) {
        this.DestinationResourceFactory.getStatus({
          id: destinationId,
          distributionType: distributionType,
          receiverId: receiverId
        }, function (status) {
          _this2.destinationStatuses[destinationId] = status.data === null || status.data === undefined ? 'false' : status.data.toString();
        });
      }
    }
  }]);

  return DynamicOrderItems;
}();